var version = '1.5.0';
export default version;